import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from "react-router-dom";

// Components
import ScrollToTop from './components/ScrollToTop';

// Main pages
import HomePage from "./pages/home/Home";

// Dojos

import './index.css';
import registerServiceWorker from './registerServiceWorker';
import StJerome from './pages/dojo/SaintJerome';
import Quebec from './pages/dojo/Quebec';
import CarteDesDojos from './pages/dojo/CarteDesDojos';
import Princeville from './pages/dojo/Princeville';
import StJeanSurRichelieu from './pages/dojo/StJeanSurRichelieu';
import ValDavid from './pages/dojo/ValDavid';
import { DojoRepository } from './pages/data/DojoRepository';
import BlackDragonMontreal from './pages/dojo/BlackDragonMontreal';
import KingseyFalls from './pages/dojo/KingseyFalls';
import SeptIles from './pages/dojo/SeptIles';
import Saguenay from './pages/dojo/Saguenay';
import VilleStLaurent from './pages/dojo/VilleStLaurent';
import Levis from './pages/dojo/Levis';
import StAdolphe from './pages/dojo/StAdolphe';
import Beloeil from './pages/dojo/Beloeil';
import Longueuil from './pages/dojo/Longueuil';
import Prevost from './pages/dojo/Prevost';
import LesEscoumins from './pages/dojo/LesEscoumins';
import Gaspe from './pages/dojo/Gaspe';
import FighterAcademy from './pages/dojo/FighterAcademy';
import { Karate } from './pages/karate/Karate';
import { Events } from './pages/event/Events';
import { Contacts } from './pages/contacts/Contacts';
import { Kangeiko2019 } from './pages/nouvelles/Kangeiko2019';

ReactDOM.render(
  <Router class="container">
    <ScrollToTop>
      <nav class="navbar-default navbar-toggleable-md navbar-inverse fixed-top bg-inverse">
        <div class="container">
          <button id="collapsedNavBtn" class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span>Menu</span>
          </button>
          <Link class="navbar-brand" to="/">
            <img class="navbar-logo" src="/images/logos/logo_QcIskf.png" alt="Québec ISKF" />
          </Link>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item active">
                <Link class="nav-link" to="/">Accueil</Link>
              </li>
              <li class="nav-item active">
                <Link class="nav-link" to="/karate">Karaté</Link>
              </li>
              <li class="nav-item active">
                <Link class="nav-link" to="/dojo">Les Dojos</Link>
              </li>
              <li class="nav-item active">
                <Link class="nav-link" to="/calendrier">Calendrier</Link>
              </li>
              <li class="nav-item active">
                <Link class="nav-link" to="/contacts">Contacts</Link>
              </li>
            </ul>
            <ul class="navbar-nav pull-right">
              <li class="nav-item">
                <a class="socialLink" target="_blank" href="https://www.facebook.com/QuebecISKF/"><i class="fa fa-facebook-square fa-2x socialIcon"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/contacts" component={Contacts} />
        <Route exact path="/nouvelles/kangeiko2019" component={Kangeiko2019} />
        <Route exact path="/dojo" component={CarteDesDojos} />
        <Route exact path="/calendrier" component={Events} />
        <Route exact path="/karate" component={Karate} />
        <Route exact path={DojoRepository.BLACK_DRAGON_MONTREAL.url} component={BlackDragonMontreal} />
        <Route exact path={DojoRepository.BELOEIL.url} component={Beloeil} />
        <Route exact path={DojoRepository.FIGHTER_ACADEMY.url} component={FighterAcademy} />
        <Route exact path={DojoRepository.GASPE.url} component={Gaspe} />
        <Route exact path={DojoRepository.KINGSEY_FALL.url} component={KingseyFalls} />
        <Route exact path={DojoRepository.LES_ESCOUMINS.url} component={LesEscoumins} />
        <Route exact path={DojoRepository.LEVIS.url} component={Levis} />
        <Route exact path={DojoRepository.LONGUEUIL.url} component={Longueuil} />
        <Route exact path={DojoRepository.PREVOST.url} component={Prevost} />
        <Route exact path={DojoRepository.PRINCEVILLE.url} component={Princeville} />
        <Route exact path={DojoRepository.QUEBEC.url} component={Quebec} />
        <Route exact path={DojoRepository.SAGUENAY.url} component={Saguenay} />
        <Route exact path={DojoRepository.SEPT_ILES.url} component={SeptIles} />
        <Route exact path={DojoRepository.ST_ADOLPHE.url} component={StAdolphe} />
        <Route exact path={DojoRepository.ST_JEAN_SUR_RICHELIEU.url} component={StJeanSurRichelieu} />
        <Route exact path={DojoRepository.ST_JEROME.url} component={StJerome} />
        <Route exact path={DojoRepository.VAL_DAVID.url} component={ValDavid} />
        <Route exact path={DojoRepository.VILLE_ST_LAURENT.url} component={VilleStLaurent} />
        <Route component={HomePage} />
      </Switch>
    </ScrollToTop>
  </Router>,
  document.getElementById('root')
);

/**
/<Route exact path="/karate" component={LeKarate} />
        <Route exact path="/iskf" component={Iskf} />
        <Route exact path="/dojo" component={LesDojos} />
        <Route exact path="/documents" component={Documents} />
        <Route exact path="/contacts" component={Contacts} />
 */

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js